import { AsyncPipe, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { SpinnerComponent } from '@sc/ui-components';
import { Observable } from 'rxjs';
import { LoadingService } from '../../services';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sc-main-loader',
  styleUrls: ['./main-loader.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, SpinnerComponent, AsyncPipe, TranslateModule],
  template: `
    <div class="loader-container" *ngIf="loading$ | async" aria-hidden="true">
      <sc-spinner></sc-spinner>
    </div>
    <span
      class="loader-indicator-text"
      aria-live="polite"
      aria-atomic="true"
      role="status"
    >
      {{
        (loading$ | async)
          ? ('GlobalApplicativeConstants.accessibility.loaderIndicator'
            | translate)
          : ''
      }}
    </span>
  `,
})
export class MainLoaderComponent {
  loading$: Observable<boolean> = this.loadingService.loading$;

  constructor(private readonly loadingService: LoadingService) {}
}
